/* Copyright 2022 VMware, Inc. All rights reserved. VMware Confidential */
import { Component, Input } from "@angular/core";

// @formatter:off
@Component({
    selector: 'property-value',
    templateUrl: './property-value.component.html',
    styleUrls: ['./property-value.component.scss']
})
// @formatter:on
export class PropertyValueComponent {

    @Input()
    name: string;

    @Input()
    id: string;

    constructor() {
    }
}
